/** Centered modal popup listing saved survey plans (load / delete). */
function PlansDrawer({ open, plans, loading, onLoad, onDelete, onClose }) {
  if (!open) return null;
  return (
    <div className="cs-modal-overlay" onClick={onClose}>
      <div className="cs-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cs-modal-header">
          <h3>Saved Plans</h3>
          <button className="cs-modal-close" onClick={onClose} title="Close">✕</button>
        </div>
        <div className="cs-modal-body">
          {loading && <span className="cs-hint">Loading…</span>}
          {!loading && plans.length === 0 && <span className="cs-hint">No saved plans yet.</span>}
          {plans.map((p) => (
            <div key={p.id} className="cs-plan-row">
              <span title={p.name}>{p.name}</span>
              <span>
                <button className="load" onClick={() => onLoad(p)}>Load</button>
                {onDelete && <button className="del" onClick={() => onDelete(p.id)}>Delete</button>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PlansDrawer;